import { useMemo } from 'react';
import { PauseCircle } from 'lucide-react';
import { LETTRE_HEX, QCM_GREEN } from '../../utils/qcmTheme';

/** Part de bonnes réponses parmi celles reçues, en pourcentage entier. */
export const pourcentageBonnes = (reponses) => {
  const recues = (reponses || []).filter((r) => r && typeof r.est_correcte === 'boolean');
  if (recues.length === 0) return null;
  return Math.round((recues.filter((r) => r.est_correcte).length / recues.length) * 100);
};

/**
 * Ce que le téléphone montre PENDANT que la correction est projetée, en mode
 * « après chaque question » (chantier jeton, 2026-09-04) : la caméra est en
 * pause, la classe regarde l'écran, et le professeur commente. Sans ce
 * bandeau, l'écran de scan restait identique et rien ne disait que le pas
 * « révéler » avait eu lieu ni pourquoi les cartes n'étaient plus lues.
 */
const BandeauCorrection = ({ bonneReponse, reponses }) => {
  const pct = useMemo(() => pourcentageBonnes(reponses), [reponses]);
  const nbBonnes = (reponses || []).filter((r) => r?.est_correcte === true).length;
  return (
    <div
      className="absolute inset-0 z-[3] flex flex-col items-center justify-center gap-4 px-8 text-center text-white"
      style={{ background: 'rgba(14,17,22,.82)' }}
      data-testid="bandeau-correction"
    >
      <p className="flex items-center gap-2 text-[12px] font-bold uppercase" style={{ letterSpacing: '.14em', color: '#a9e8c9' }}>
        <PauseCircle size={16} /> Correction projetée · scan en pause
      </p>
      {bonneReponse ? (
        <div
          className="flex items-center justify-center w-[76px] h-[76px] rounded-2xl font-black text-4xl"
          style={{ background: LETTRE_HEX[bonneReponse] || QCM_GREEN, fontFamily: "'Archivo', 'Inter', system-ui, sans-serif" }}
        >
          {bonneReponse}
        </div>
      ) : null}
      {pct === null ? (
        <p className="text-sm" style={{ color: '#aab3a8' }}>Aucune réponse reçue.</p>
      ) : (
        <p className="text-sm" style={{ color: '#aab3a8' }}>
          <span className="font-black text-2xl text-white">{pct} %</span> de bonnes réponses
          <span className="block text-[12px] mt-0.5">{nbBonnes} sur {reponses.length}</span>
        </p>
      )}
      <p className="text-[13px]" style={{ color: 'rgba(255,255,255,.6)' }}>
        Commentez, puis « Suivant » pour la question d'après.
      </p>
    </div>
  );
};

export default BandeauCorrection;
